"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HCaptcha = void 0;
const library_1 = require("../../core/library");
const helper_1 = require("../../core/library/helper");
const loader_1 = require("./loader");
class HCaptcha extends library_1.Library {
    constructor(hCaptchaSiteKey) {
        super('HCaptcha', new loader_1.HCaptchaLoader());
        this.hCaptchaSiteKey = hCaptchaSiteKey;
        return (0, helper_1.withLibraryLoadCheck)(this);
    }
    getHCaptchaSiteKey() {
        return this.hCaptchaSiteKey;
    }
    execute(widgetID) {
        return __awaiter(this, void 0, void 0, function* () {
            return window.hcaptcha.execute(widgetID, {
                async: true,
            });
        });
    }
    render(element, opts) {
        return window.hcaptcha.render(element, Object.assign(Object.assign({}, opts), { sitekey: this.getHCaptchaSiteKey() }));
    }
    reset(widgetID) {
        window.hcaptcha.reset(widgetID);
    }
    remove(widgetID) {
        window.hcaptcha.remove(widgetID);
    }
    getResponse(widgetID) {
        return window.hcaptcha.getResponse(widgetID);
    }
    getRespKey(widgetID) {
        return window.hcaptcha.getRespKey(widgetID);
    }
}
exports.HCaptcha = HCaptcha;
//# sourceMappingURL=index.js.map